import { RolloutInstructionDescription } from '#components/automated-rollouts/guarded-rollouts/review-save';
import type { Clause } from '#utils/clause/records/Clause';
import type { Variation } from '#utils/flags/records/Variation';
import type { SemanticInstructionProgressiveRolloutConfiguration } from '#utils/instructions/shared/types';

import { ClauseInstructionDescription } from './ClauseInstructionDescription';

interface BaseProps {
  variations: Variation[];
  progressiveRolloutConfiguration: SemanticInstructionProgressiveRolloutConfiguration;
  rolloutContextKind: string;
}

interface WithClauseDescription {
  clauses: Clause[];
  projKey: string;
  envKey: string;
}

type ProgressiveRolloutConfigurationDescriptionProps = (BaseProps & WithClauseDescription) | BaseProps;

export const ProgressiveRolloutConfigurationDescription = (props: ProgressiveRolloutConfigurationDescriptionProps) => {
  const { variations, progressiveRolloutConfiguration, rolloutContextKind } = props;

  const stages = progressiveRolloutConfiguration.stages.map((stage) => ({
    rolloutWeight: stage.rollout[progressiveRolloutConfiguration.endVariationId] || 0,
    monitoringWindowMilliseconds: stage.durationMs,
  }));

  return (
    <>
      {'clauses' in props &&
        props.clauses.map((clause, indx) => {
          const clauseArrLength = props.clauses.length;
          let extraText;
          if (indx !== clauseArrLength - 1) {
            extraText = ' and ';
          }
          return (
            <ClauseInstructionDescription
              projKey={props.projKey}
              envKey={props.envKey}
              key={indx}
              clause={clause}
              extraText={extraText}
            />
          );
        })}
      <RolloutInstructionDescription
        originalVariationId={progressiveRolloutConfiguration.controlVariationId}
        targetVariationId={progressiveRolloutConfiguration.endVariationId}
        rolloutContextKind={rolloutContextKind}
        variations={variations}
        stages={stages}
      />
    </>
  );
};
